export default __webpack_public_path__ + "media/artificial-intelligence.d6781b510c8154b3c468d94ccf052bf3.svg";